<template>
  <div class="root-content" :style="cssVars">
    <div class="payment-container">
      <b-card no-body class="border-0 shadow payment-card"  v-if="!this.disable2C2PPayment">
        <div class="payment-method-header d-flex justify-content-between">
          <b-form-radio size="lg" v-if="!this.disableBankPayment" v-model="paymentMethod" :value="0" :disabled="checkDisableMethod(0)">
            <h6 class="method-checkbox-label">บัตรเครดิต / บัตรเดบิต</h6>
          </b-form-radio>
          <h6 class="method-checkbox-label" v-if="this.disableBankPayment">บัตรเครดิต / บัตรเดบิต</h6>
          <div class="cards-icon-group justify-content-end mr-3 d-lg-none">
            <div class="bg-img img-mastercard"></div>
            <div class="bg-img img-visa"></div>
          </div>
        </div>
        <b-collapse :visible="paymentMethod == 0">
          <div class="row mt-3">
            <div class="col-lg-8 col-md-12">
              <div class="row">
                <b-form-group
                  class="col-12"
                  :invalid-feedback="v_cardNo.message"
                >
                  <b-input-group
                    class="custom-input-group"
                    :class="{
                      'is-invalid': v_cardNo.state == false
                    }"
                  >
                    <b-input-group-prepend>
                      <b-input-group-text class="bg-transparent"
                        ><b-icon icon="credit-card2-front"></b-icon
                      ></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-mask="'#### #### #### ####'"
                      v-model="cardNo"
                      placeholder="ใส่หมายเลขบัตรเครดิต"
                      autocomplete="off"
                      :state="v_cardNo.state"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-12"
                  :invalid-feedback="v_cardholderName.message"
                >
                  <b-input-group
                    class="custom-input-group"
                    :class="{
                      'is-invalid': v_cardholderName.state == false
                    }"
                  >
                    <b-input-group-prepend>
                      <b-input-group-text class="bg-transparent"
                        ><b-icon icon="person-circle"></b-icon
                      ></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="cardholderName"
                      placeholder="ใส่ชื่อเจ้าของบัตร"
                      :state="v_cardholderName.state"
                      autocomplete="off"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group class="col-6">
                  <b-input-group class="custom-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text class="bg-transparent"
                        ><b-icon icon="calendar3"></b-icon
                      ></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="cardExp"
                      v-mask="'##/##'"
                      placeholder="MM/YY"
                      autocomplete="off"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group class="col-6">
                  <b-input-group class="custom-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text class="bg-transparent"
                        ><b-icon icon="credit-card2-back"></b-icon
                      ></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      :type="showPassword ? 'text' : 'password'"
                      v-model="cardCCV"
                      v-mask="'####'"
                      placeholder="CCV"
                      autocomplete="off"
                      style="border-right:0"
                    ></b-form-input>
                    <div class="input-group-append border-0">
                      <span
                        class="input-group-text bg-transparent"
                        @click="showPassword = !showPassword"
                      >
                        <i
                          class="fa"
                          :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </div>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="col-lg-4 d-none d-lg-block">
              <div class="credit-img-container">
                <div class="bg-img img-credit-card" style="height:70%"></div>
                <div
                  class="cards-icon-group justify-content-end mr-3"
                  style="height:30%"
                >
                  <div class="bg-img img-mastercard"></div>
                  <div class="bg-img img-visa"></div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
      <b-card no-body class="border-0 shadow payment-card2" v-if="!this.disableBankPayment">
        <div class="payment-card-content">
          <div class="payment-method-header d-flex justify-content-between">
            <b-form-radio size="lg" v-model="paymentMethod" :value="1" :disabled="checkDisableMethod(1)">
              <h5 class="method-checkbox-label">ชำระเงินผ่าน QR Code</h5>
            </b-form-radio>
          </div>
        </div>
        <b-collapse :visible="paymentMethod == 1">
          <div class="d-flex flex-column align-items-center">
            <div class="promtpay-qr-img"></div>
            <div class="attach-slip-container">
              <h6 class="m-0 font-size-1">หลักฐานการชำระเงิน</h6>
              <button
                class="attach-slip-btn mt-4"
                @click="$refs.qrInputFile.click()"
                :class="{ img: qrFile }"
              >
                <div class="attach-slip-btn-content" v-if="!qrFile">
                  อัปโหลดใบเสร็จการชำระเงิน
                </div>
                <img
                  :src="qrAttachImg"
                  alt="Attach Slip"
                  class="attach-slip-btn-img"
                  v-if="qrFile"
                />
              </button>
              <input
                type="file"
                class="d-none"
                ref="qrInputFile"
                @change="qrFileChange($event)"
                accept="image/*"
              />
              <h6 class="mt-5">
                หมายเหตุ: หลังจากการชำระเงิน กรุณาอัปโหลดใบเสร็จการชำระเงิน
              </h6>
            </div>
          </div>
        </b-collapse>
      </b-card>
      <b-card no-body class="border-0 shadow payment-card2" v-if="!this.disableBankPayment">
        <div class="payment-card-content">
          <div class="payment-method-header d-flex justify-content-between">
            <b-form-radio size="lg" v-model="paymentMethod" :value="2" :disabled="checkDisableMethod(2)">
              <h5 class="method-checkbox-label">ชำระผ่านธนาคาร</h5>
            </b-form-radio>
          </div>
        </div>
        <b-collapse :visible="paymentMethod == 2">
          <div class="d-flex align-items-center ml-md-5 ml-3">
            <div class="bank-logo-img"></div>
            <div class="banking-account-detail ml-3 ml-md-4">
              บัญชี ธนาคารกรุงไทย<br />
              ชื่อบัญชี สำนักงานราชบัณฑิตยสภาเพื่อการรับเงิน<br />
              เลขที่ 006-6-07606-4
            </div>
          </div>
          <div class="d-flex flex-column align-items-center mt-3">
            <div class="attach-slip-container">
              <h6 class="m-0 font-size-1">หลักฐานการชำระเงิน</h6>
              <button
                class="attach-slip-btn mt-4"
                @click="$refs.transferInputFile.click()"
                :class="{ img: transferFile }"
              >
                <div class="attach-slip-btn-content" v-if="!transferFile">
                  อัปโหลดใบเสร็จการชำระเงิน
                </div>
                <img
                  :src="transferAttachImg"
                  alt="Attach Slip"
                  class="attach-slip-btn-img"
                  v-if="transferFile"
                />
              </button>
              <input
                type="file"
                class="d-none"
                ref="transferInputFile"
                @change="transferFileChange($event)"
                accept="image/*"
              />
              <h6 class="mt-5">
                หมายเหตุ: หลังจากการชำระเงิน กรุณาอัปโหลดใบเสร็จการชำระเงิน
              </h6>
            </div>
          </div>
        </b-collapse>
      </b-card>
      <b-card no-body class="border-0 shadow payment-card2" v-if="!this.disableBankPayment">
        <div class="payment-card-content">
          <div class="payment-method-header d-flex justify-content-between">
            <b-form-radio size="lg" v-model="paymentMethod" :value="3" :disabled="checkDisableMethod(3)">
              <h5 class="method-checkbox-label">ชำระเงินสด</h5>
            </b-form-radio>
          </div>
        </div>
      </b-card>
    </div>
    <form
      ref="form_2c2p"
      :action="paymentCartSubmitionURL"
      method="POST"
      class="h-0"
    >
      <input
        type="hidden"
        data-encrypt="cardnumber"
        maxlength="16"
        :value="cardNo1"
      /><br />
      <input
        type="hidden"
        data-encrypt="month"
        maxlength="2"
        :value="month"
      /><br />
      <input
        type="hidden"
        data-encrypt="year"
        maxlength="4"
        :value="year"
      /><br />
      <input
        type="hidden"
        data-encrypt="cvv"
        maxlength="4"
        :value="cardCCV"
      /><br />
      <input type="hidden" name="amount" :value="amount" /><br />
      <input
        type="hidden"
        name="cardholderName"
        :value="cardholderName"
      /><br />
      <input type="hidden" name="relatedId" :value="relatedId" /><br />
      <input type="hidden" name="relatedType" :value="relatedType" /><br />
      <input type="hidden" name="refNo" :value="refNo" /><br />
      <input type="hidden" name="description" :value="description" /><br />
      <input type="hidden" name="token" :value="token" /><br />
    </form>
    <!-- <b-button @click="submit2c2p">Submit 2C2P</b-button> -->
  </div>
</template>

<script>
import { getMy2c2p } from "../libs/my2c2p";
import { paymentService } from "../services/api.service";
import { emptyGuid } from "../libs/util";
import { createValidation } from "../libs/ValidationHelper";
import { DISABLE_2C2P_PAYMENT } from "../libs/config";
import { DISABLE_BANK_PAYMENT } from "../libs/config";
import jwtService from "../services/jwt.service";
const validate = createValidation();
export default {
  props: {
    disableMethods: {
      type: Array,
      default: () => []
    },
    defaultMethod: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      cardNo: null,
      cardholderName: null,
      cardExp: null,
      cardCCV: null,
      relatedId: emptyGuid,
      relatedType: 0,
      paymentMethod: 0,
      qrFile: null,
      qrAttachImg: null,
      transferFile: null,
      transferAttachImg: null,
      amount: 0,
      description: null,
      refNo: null,
      isCheckValidate: false,
      showPassword: false,
      token: null,
      image: {
        credit_card: require("../assets/credit-card.png"),
        mastercard: require("../assets/mastercard.png"),
        promtpay_qr: require("../assets/promtpay-qr.png"),
        visa: require("../assets/visa.png"),
        scb_logo: require("../assets/scb-logo.png")
      },
      disable2C2PPayment: DISABLE_2C2P_PAYMENT,
      disableBankPayment: DISABLE_BANK_PAYMENT
    };
  },
  computed: {
    month() {
      const pattern = /^(\d{2})\/(\d{2})$/;
      if (this.cardExp && this.cardExp.match(pattern))
        return this.cardExp.match(pattern)[1];
      return "";
    },
    year() {
      const pattern = /^(\d{2})\/(\d{2})$/;
      if (this.cardExp && this.cardExp.match(pattern)) {
        return "20" + this.cardExp.match(pattern)[2];
      }
      return "";
    },
    cardNo1() {
      return (this.cardNo || "").split(" ").join("");
    },
    paymentCartSubmitionURL() {
      return this.axios.defaults.baseURL + "/Payment/Card";
    },
    ...validate.initFuncs({
      v_cardholderName() {
        const pattern = /^[A-Z][A-Za-z ]+$/;
        if (!this.cardholderName || this.cardholderName.trim() == "")
          return "กรุณากรอกชื่อผู้ถือบัตร";
        if (!pattern.test(this.cardholderName))
          return "ชื่อผู้ถือบัตรไม่ถูกต้อง";
        return null;
      },
      v_cardNo() {
        if (!this.cardNo || this.cardNo.trim() == "")
          return "จำเป็นต้องระบุหมายเลขบัตร";
        return null;
      }
    }),
    cssVars() {
      return {
        "--icon-credit-card": "url('" + this.image.credit_card + "')",
        "--icon-mastercard": "url('" + this.image.mastercard + "')",
        "--icon-promtpay-qr": "url('" + this.image.promtpay_qr + "')",
        "--icon-visa": "url('" + this.image.visa + "')",
        "--icon-scb-logo": "url('" + this.image.scb_logo + "')"
      };
    }
  },
  watch: {
    defaultMethod: function(val) {
      this.paymentMethod = val;
    }
  },
  methods: {
    setPaymentData(relatedType, relatedId, amount, refNo = null, desc = null) {
      this.relatedId = relatedId;
      this.relatedType = relatedType;
      this.amount = amount;
      this.refNo = refNo;
      this.description = desc;
    },
    paymentMethodChange(paymentMethod) {
      this.paymentMethod = paymentMethod;
    },
    onFormCardSubmit(e) {
      //e.preventDefault();
      console.log(e);
      debugger;
    },
    checkDisableMethod(paymentMethod) {
      return this.disableMethods && this.disableMethods.includes(paymentMethod);
    },
    submit2c2p() {
      this.token = jwtService.getToken();
      this.$nextTick(function() {
        My2c2p.submitForm(this.$refs.form_2c2p, function(errCode, errDesc) {
          if (errCode != 0) {
            alert(errDesc + " (" + errCode + ")");
          }
        });
      });
    },
    qrFileChange(e) {
      const self = this;
      const file = e.target.files[0];
      if (file && file.type.split("/")[0] != "image") {
        //Validate file for image
        alert("กรุณาเลือกรูปภาพ");
        e.preventDefault();
        return;
      }
      this.qrFile = file;
      this.qrAttachImg = null;

      if (this.qrFile) {
        var reader = new FileReader();
        reader.onload = function(event) {
          self.qrAttachImg = event.target.result;
        };
        reader.readAsDataURL(this.qrFile);
      }
    },
    transferFileChange(e) {
      const self = this;
      const file = e.target.files[0];
      if (file && file.type.split("/")[0] != "image") {
        //Validate file for image
        alert("กรุณาเลือกรูปภาพ");
        e.preventDefault();
        return;
      }
      this.transferFile = file;
      this.transferAttachImg = null;
      if (this.transferFile) {
        var reader = new FileReader();
        reader.onload = function(event) {
          self.transferAttachImg = event.target.result;
        };
        reader.readAsDataURL(this.transferFile);
      }
    },
    submit() {
      const self = this;
      validate.uncheck(self);
      return new Promise(function(resolve, reject) {
        switch (self.paymentMethod) {
          case 0: {
            if (!validate.check(self)) break;
            self.submit2c2p();
            break;
          } //Credit Card
          case 1: {
            //QR
            if (!self.qrFile) {
              alert("กรุณาแนบหลักฐานการชำระ");
              return;
            }
            paymentService
              .submitQRPayment(
                self.qrFile,
                self.relatedId,
                self.relatedType,
                self.amount
              )
              .then(res => {
                resolve(res);
              })
              .catch(err => {
                reject(err);
              });
            break;
          }
          case 2: {
            //Transfer
            if (!self.transferFile) {
              alert("กรุณาแนบหลักฐานการชำระ");
              return;
            }
            paymentService
              .submitTransferPayment(
                self.transferFile,
                self.relatedId,
                self.relatedType,
                self.amount
              )
              .then(res => {
                resolve(res);
              })
              .catch(err => {
                reject(err);
              });
            break;
          }
          case 3: {
            paymentService
              .submitCashPayment(
                self.relatedId,
                self.relatedType,
                self.amount
              )
              .then(res => {
                resolve(res);
              })
              .catch(err => {
                reject(err);
              });
            break;
          }
        }
      });
    }
  },
  mounted() {
    this.paymentMethod = this.defaultMethod;
    getMy2c2p().then(My2c2p => {
      My2c2p.onSubmitForm(this.$refs.form_2c2p, function(errCode, errDesc) {
        if (errCode != 0) {
          alert(errDesc + " (" + errCode + ")");
        }
      });
    });
  }
};
</script>

<style scoped>
.h-0 {
  height: 0;
}
.root-content {
  max-width: 720px;
  padding-left: 15px;
  padding-right: 15px;
}
.payment-card {
  padding: 1.5rem;
}
.payment-card2 {
  margin-top: 1.5rem;
}
.payment-card-content {
  padding: 1.5rem;
}
.method-checkbox-label {
  font-size: 1rem;
  margin-bottom: 0;
  margin-top: 0.5rem;
}
.custom-input-group .input-group-prepend .input-group-text {
  border-right: 0;
  padding-right: 5px;
}
.custom-input-group > .input-group-append > .input-group-text {
  border-left: 0;
}
.custom-input-group input {
  border-left: 0;
}
.credit-img-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.bg-img {
  background-size: contain;
  background-repeat: no-repeat;
}
.bg-img.img-credit-card {
  background-image: var(--icon-credit-card);
  width: 190px;
  height: 150px;
}
.cards-icon-group {
  display: flex;
  align-items: center;
}
.bg-img.img-mastercard {
  background-image: var(--icon-mastercard);
  width: 48px;
  height: 28px;
}
.bg-img.img-visa {
  background-image: var(--icon-visa);
  width: 50px;
  height: 15px;
  margin-left: 10px;
}
.promtpay-qr-img {
  background-image: var(--icon-promtpay-qr);
  background-size: contain;
  background-repeat: no-repeat;
  height: 290px;
  width: 240px;
}
.attach-slip-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f2f2f2;
  width: 100%;
  padding: 1.5rem;
}
.attach-slip-btn {
  border: 2px dashed #dddddd;
  border-radius: 4px;
  background: transparent;
  max-width: 400px;
  width: 100%;
  padding: 1rem;
  height: 80px;
}
.attach-slip-btn.img {
  height: 310px;
}
.attach-slip-btn-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.attach-slip-btn-img {
  object-fit: contain;
  max-width: 100%;
  height: 100%;
}
.bank-logo-img {
  background-image: var(--icon-scb-logo);
  background-size: contain;
  background-repeat: no-repeat;
  height: 100px;
  width: 100px;
}
.banking-account-detail {
  font-size: 1rem;
  font: normal normal medium 18px/28px;
}
</style>
